<h4 [ngClass]="{
    'blue-header-text': !pinkheader,
    'pink-header-text': pinkheader
  }">{{message}}</h4>